export const CLIENT_NAME_FIELD = 'Name';
export const CLIENT_REPRESENTATIVE_NAME_FIELD = 'ClientRepresentative.Name';
export const CLIENT_REPRESENTATIVE_EMAIL_FIELD = 'ClientRepresentative.Email';
export const CLIENT_REPRESENTATIVE_PHONE_FIELD = 'ClientRepresentative.Phone';
export const BB_REPRESENTATIVE_NAME_FIELD = 'BlueByteRepresentative.Name';
export const BB_REPRESENTATIVE_EMAIL_FIELD = 'BlueByteRepresentative.Email';
export const BB_REPRESENTATIVE_PHONE_FIELD = 'BlueByteRepresentative.Phone';

export const ALLOWED_FIELDS = [
    CLIENT_NAME_FIELD,
    CLIENT_REPRESENTATIVE_NAME_FIELD,
    CLIENT_REPRESENTATIVE_EMAIL_FIELD,
    CLIENT_REPRESENTATIVE_PHONE_FIELD,
    BB_REPRESENTATIVE_NAME_FIELD,
    BB_REPRESENTATIVE_EMAIL_FIELD,
    BB_REPRESENTATIVE_PHONE_FIELD,
];

export const CLIENT_INFO_STEP_TITLE = 'clientInfo';

export const ADMIN_CENTER_ENTITY_TYPE = {
    CLIENT: 'Client',
    REPRESENTATIVE: 'Representative',
} as const;

export const ADMIN_CENTER_FIELD_NAME = {
    NAME: 'Name',
    EMAIL: 'Email',
    PHONE: 'Phone',
} as const;
